<template>
    <div class="login">
        <div class="container">
            <div class="title">{{getEpName()}}</div>
            <div class="sub-title">后台管理系统</div>
            <div class="input-group" v-on:keyup.enter="submit">
                <input name="username" class="user" placeholder="账号" v-model="username"/>
                <input name="password" class="pass" type="password" placeholder="密码" v-model="password"/>
            </div>
            <el-button class="btn"  type="primary" @click="submit">登录</el-button>
        </div>
        <div class="footer">Copyright © 2020 All Rights Reserved. {{getEpName()}}  版权所有</div>
    </div>
</template>
<script>
    import {mapActions} from "vuex";
    import authApi from "../api/auth";

    export default {
        data: function () {
            return {
                username: "",
                password: ""
            };
        },
        created: function () {
        },
        mounted: function () {
        },
        methods: {
            ...mapActions("auth", ["login"]),
            getEpName: function() {
              return process.env.VUE_APP_NAME;
            },
            submit: function () {
                if(!this.username || !this.password) {
                    this.$message.warning("请填写完整的账户名密码！");
                    return;
                }
                const loading = this.$loading({text: '登录中...'});
                this.login({username: this.username, password: this.password}).then(result => {
                    loading.close();
                    this.$router.replace("/");
                }).catch(() => loading.close());
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../less/login";
</style>
